/**
 * Checks if the provided ratio is a valid string in the format "X:Y".
 * Invalid ratios will default to the predefined values (e.g. "Default for current module").
 * @param ratio - The ratio string to validate
 * @returns {boolean} - Returns true if the ratio is valid, false otherwise
 */
export const isValidRatio = (ratio: string | undefined): boolean => {
  return typeof ratio === 'string' && /^\d+:\d+$/.test(ratio);
};
